import React, { useState, useEffect } from 'react';
import { Typography, Paper, Badge } from '@mui/material';
import { CancelRounded, CheckCircleRounded } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      right: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const SubmissionStatus = ({ pStatusName, isSelected, isDesktopLarge, jobId, submissionId }) => {
  const [displayStatus, setDisplayStatus] = useState(pStatusName);

  useEffect(() => {
    setDisplayStatus(pStatusName);
  }, [pStatusName]);

  useEffect(() => {
    const handleStatusUpdate = (event) => {
      if (event.detail?.submissionId === submissionId) {
        if (event.detail?.newStatus) {
          setDisplayStatus(event.detail.newStatus);
        }
      }
    };
    window.addEventListener('statusUpdate', handleStatusUpdate);
    return () => {
      window.removeEventListener('statusUpdate', handleStatusUpdate);
    };
  }, [submissionId]);

  return (
    <Typography
      component={Paper}
      elevation={isSelected ? 1 : 0}
      sx={{
        fontSize: isDesktopLarge ? "10px" : "8px",
        margin: 0,
        padding:
          displayStatus === "Rejected" ||
            displayStatus === "Selected"
            ? "2px 4px 2px 4px"
            : "2px 12px 2px 4px",
        borderRadius: "4px",
        bgcolor:
          displayStatus === "Rejected" ||
            displayStatus === "Job Rejected By Candidate" ||
            displayStatus === "Profile Rejected By Vendor"
            ? "#f9dedc"
            : "rgba(255, 236, 179, 0.5)",
        color:
          displayStatus === "Rejected" ||
            displayStatus === "Job Rejected By Candidate" ||
            displayStatus === "Profile Rejected By Vendor"
            ? "#410E0B"
            : "#221B04",
      }}
    >
      {displayStatus && displayStatus}
      &nbsp;&nbsp;&nbsp;
      {/* Red cross icon for all rejection types */}
      {(displayStatus === "Rejected" ||
        displayStatus === "Job Rejected By Candidate" ||
        displayStatus === "Profile Rejected By Vendor") && (
          <CancelRounded
            sx={{
              color: "red",
              border: "1px solid #fff",
              borderRadius: "10px",
              fontSize: "12px",
            }}
          />
        )}
      {/* Green dot for in-progress statuses */}
      {displayStatus !== "Rejected" &&
        displayStatus !== "Job Rejected By Candidate" &&
        displayStatus !== "Profile Rejected By Vendor" &&
        displayStatus !== "Selected" && (
          <StyledBadge
            overlap="circular"
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            variant="dot"
          ></StyledBadge>
        )}
      {/* Check icon for Selected */}
      {displayStatus === "Selected" && (
        <CheckCircleRounded
          sx={{
            color: "#44b700",
            border: "1px solid #fff",
            borderRadius: "10px",
            fontSize: "12px",
          }}
        />
      )}
    </Typography>
  );
};

export default SubmissionStatus;